import { ModelBase, Property } from '@skylab-shared/core';
import { UserPermissionKind } from './user-permission-kind';

export class UserModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    public firstName: string;

    @Property()
    public lastName: string;

    @Property()
    public roleId: number;

    @Property()
    public roleName: string;

	@Property()
    public userPermissionKinds: UserPermissionKind[];
}
